module.exports = "https://static.im-cdn.com/mjc/storefront/Compass/static/media/Linkedin.92566194.svg";